import { Component, Input } from "@angular/core";
import { ErrorComponentBase } from "../error.decorator";
import { IMenu } from "app/types/menu";

export interface Error403PageComponent extends ErrorComponentBase { }
@Component({
    selector: "error-403-page-component",
    templateUrl: "../error.view.html",
    standalone: false
})
@ErrorComponentBase
export class Error403PageComponent {

  @Input() error: { [key: string]: any };
  @Input() home: IMenu = null;
  @Input() sections: IMenu[] = [];

  code: string = '403';
  subTitle: string = "Forbidden";
  lead: string = `We are sorry, but you do not have access to this page or resource.`

}
